module.exports = __webpack_public_path__ + "static/media/Electric_Range_Active.80654c38.svg";